<div class="scan-wrapper">
  <div class="header-container">
    <div class="title">{{matName}}</div>

    <div *ngIf="isMobile && videoDevices.length > 1" class="camera-switch-container">
      <button class="btn-switch" (click)="$event.stopPropagation(); toggleCamera()">
        <i class="pi pi-replay"></i><i class="pi pi-camera"></i>
      </button>
    </div>
  </div>
  <div *ngIf="capturas > 1 && orientacion==2">Este material esta orientado verticalmente</div>
   <div *ngIf="capturas > 1 && orientacion==1">Este material esta orientado horizontalmente </div>
   <div class="d-flex justify-content-center align-items-center icons mb-1">
    <button class="icon-rotar" aria-label="Rotar" (click)="toggleMirror()">
      <i class="pi pi-arrow-right-arrow-left"></i>
    </button>
   </div>
  <div class="card camera-container">

    <div class="video-area">
      <video #video autoplay playsinline [hidden]="isPreviewing" (click)="triggerAutoFocus()"></video>
      <div *ngIf="isPreviewing" class="preview-container">
        <img [src]="previewImage" alt="Vista previa" class="preview-image" />
      </div>
      <img [src]="currentmask" alt="Mask" class="video-mask" [ngClass]="{ 'flip-horizontal': isMirrored }"/>
    </div>


        <div class="capture-counter" *ngIf="capturas > 1">
            Captura {{ capturesTaken }} de {{ capturas }}
        </div>

    <div class="action-buttons">

      <button (click)="onRepetir()" class="btn-repetir" *ngIf="this.capturesTaken > 0">
        <i class="pi pi-refresh"></i> Repetir
      </button>

      <button (click)="onCancel()" class="btn-cancel">Cancelar</button>
      
      <button class="btn-capture" type="button" (click)="captureImage()" *ngIf="this.capturesTaken < this.capturas">
        <i class="pi pi-camera"></i> Capturar
      </button>

      <button class="btn-capture" type="button" (click)="nextMultipleCaptures()" *ngIf="this.capturesTaken == this.capturas">
        <i class="pi pi-arrow-right"></i> Siguiente
      </button>
      <!-- <button class="btn-capture" type="button" (click)="onCapture('')">
        <i class="pi pi-camera"></i> next
      </button>-->
    </div>



  </div>

  <!-- Cuando sea varias capturas y entre desde una version se agregan miniaturas -->
  <div *ngIf="dataParam.version != null && capturas > 1">
    <div class="capture-counter" >
      Vista Previa
    </div>
    
    <!-- Horizontal -->
    <div *ngIf="orientacion == 1">
      <div *ngIf="croppedImages.length > 0">
        <!-- Captura -->
        <div class="d-flex align-items-center justify-content-center">
          <img 
          [src]="croppedImages[croppedImages.length-1]"
          [alt]="'captura'"
          class="img-fluid h-100 object-fit-contain"
          />
        </div>
      </div>
      <!-- Imagen completa de la version -->
      <div class="d-flex align-items-center justify-content-center">
        <div class="visor-wrapper" #visorWrapper>
          <img [src]="dataParam.version.url" alt="" class="img-fluid h-100 object-fit-contain imagen-material">
          <div
            class="recuadro-amarillo"
            [style.width.%]="calcularAnchoRecuadro()"
            [style.left.%]="calcularPosicionLeft()"
            [class.mostrar-borde]="recuadroVisble"
          ></div>
        </div>
      </div>
    </div>

    <!-- Vertical -->
    <div *ngIf="orientacion == 2">

      <div class="row">

        <div class="col-md-6" style="min-height: 100px;">
          <div *ngIf="croppedImages.length > 0">
            <!-- Captura -->
            <div class="d-flex align-items-center justify-content-center">
              <img [src]="croppedImages[croppedImages.length-1]" [alt]="'captura'" class="img-fluid object-fit-contain" style="max-height: 100%; width: auto;" />
            </div>
          </div>
        </div>

        <div class="col-md-6" style="min-height: 100px;">
          <!-- Imagen completa de la version -->
          <div class="d-flex align-items-center justify-content-center">
            <div class="visor-wrapper" #visorWrapper>
              <img [src]="dataParam.version.url" alt="" class="img-fluid object-fit-contain imagen-material" style="max-height: 100%; width: auto;">
              <div
                class="recuadro-amarillo"
                [style.width.%]="calcularAnchoRecuadro()"
                [style.left.%]="calcularPosicionLeft()"
                [class.mostrar-borde]="recuadroVisble"
              ></div>
            </div>
          </div>

        </div>

      </div>

    </div>

  </div>
  
  <p *ngIf="camerror != ''">Código de error: {{camerror}}</p> 
      <canvas #canvas hidden></canvas> 
    <!-- <img *ngIf="capturedImage" [src]="capturedImage" alt="Captura" />-->
     <!--<img *ngIf="croppedImage" [src]="croppedImage" />-->

</div>